var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('video',{staticClass:"video-js vjs-default-skin",attrs:{"id":"my-video","controls":"","preload":"auto"}},[_c('source',{attrs:{"src":"https://livertc.wzhyt.cn/live/movie.m3u8","type":"application/x-mpegURL"}})])])
}]

export { render, staticRenderFns }